import React, { useState, useEffect, useRef } from 'react';
import { Button } from 'react-bootstrap';
import styles from './styles.module.scss';

function InvitationFormMobile({ configurationMobile, handleFormDataFather, handleClickBackFather, handleSaveFormDataFather, data = null, imgInvitation }) {
  // Estado para almacenar los datos del formulario
  const [formData, setFormData] = useState({
    event_name: '',
    event_date: '',
    time: '',
    celebrate_name: '',
    address: '',
    message: '',
  });
  const [dataInvitation, setDataInvitation] = useState([]);

  // Manejar cambios en los campos del formulario
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  // Manejar el envío del formulario
  const handleSubmit = (e) => {
    e.preventDefault();
    // Aquí puedes realizar cualquier acción que desees con los datos del formulario
    console.log('Datos del formulario:', formData);

    // Puedes convertir los datos en formato JSON si es necesario
    const jsonData = JSON.stringify(formData);
    console.log('Datos en formato JSON:', jsonData);
    handleSaveFormDataFather(jsonData);
  };

  useEffect(() => {
    handleFormDataFather(JSON.stringify(formData));
  }, [formData]);

  useEffect(() => {
    if (data) {
      console.log('if data en edit invitacion', data);
      formData.event_name = data?.event_name;
      formData.event_date = data?.event_date;
      formData.time = data?.time;
      formData.celebrate_name = data?.celebrate_name;
      formData.address = data?.address;
      formData.message = data?.message;

      let dateLabel = '';
      if (data?.event_date) {
        const partesFecha = formData.event_date.split('-');
        if (partesFecha.length === 3) {
          dateLabel = `${partesFecha[2]}-${partesFecha[1]}-${partesFecha[0]}`;
        }
      }
      const tmpDataInvitacion = {
        event_name: data?.event_name,
        event_date: dateLabel,
        event_hour: data?.time,
        name: data?.celebrate_name,
        address: data?.address,
        message: data?.message,
        template_url: imgInvitation,
      };
      setDataInvitation(tmpDataInvitacion);
    };
  }, [data]);


  console.log('data en edit invitacion', data);


  const [showEventNameInput, setShowEventNameInput] = useState(false);
  const [showEventDateInput, setShowEventDateInput] = useState(false);
  const [showEventHourInput, setShowEventHourInput] = useState(false);
  const [showCelebrateNameInput, setShowCelebrateNameInput] = useState(false);
  const [showPlaceEventInput, setShowPlaceEventInput] = useState(false);
  const [showMessageInput, setShowMessageInput] = useState(false);

  const [enableEdit, setEnableEdit] = useState(false);

  const inputEventNameRef = useRef(null);
  const inputEventDateRef = useRef(null);
  const inputEventHourRef = useRef(null);
  const inputCelebrateNameRef = useRef(null);
  const inputPlaceEventRef = useRef(null);
  const inputMessageRef = useRef(null);


  const showHideEventNameInput = () => {
    setShowEventNameInput(!showEventNameInput);
  };
  const showHideEventDateInput = () => {
    setShowEventDateInput(!showEventDateInput);
  };
  const showHideEventHourInput = () => {
    setShowEventHourInput(!showEventHourInput);
  };
  const showHideCelebrateNameInput = () => {
    setShowCelebrateNameInput(!showCelebrateNameInput);
  };

  const showHidePlaceEventInput = () => {
    setShowPlaceEventInput(!showPlaceEventInput);
  }

  const showHideMessageInput = () => {
    setShowMessageInput(!showMessageInput);
  }

  const handleEdit = () => {
    setEnableEdit(!enableEdit);
  };

  useEffect(() => {
    if (showEventNameInput) {
      inputEventNameRef.current.focus();
    }
    if (showEventDateInput) {
      inputEventDateRef.current.focus();
    }
    if (showEventHourInput) {
      inputEventHourRef.current.focus();
    }
    if (showCelebrateNameInput) {
      inputCelebrateNameRef.current.focus();
    }
    if (showPlaceEventInput) {
      inputPlaceEventRef.current.focus();
    }
    if (showMessageInput) {
      inputMessageRef.current.focus();
    }
  }, [showEventNameInput, showEventDateInput, showEventHourInput, showCelebrateNameInput, showPlaceEventInput, showMessageInput]);

  const divStyle ={
    position: 'relative',
    width: '100%', // Ajusta según sea necesario
    height: '700px', // Ajusta según sea necesario
    rounded: 'true',
    backgroundImage: `url(${dataInvitation?.template_url ? dataInvitation.template_url : imgInvitation})`,
    backgroundSize: '100% 100%',
    marginBottom: '20px',
    padding: '20px',
    backgroundPosition:'center',
    borderRadius: '50px',
    backgroundRepeat: 'no-repeat'
    
  }
console.log('+++++++++++++++++++++++++++++INVITATION FORM MOBILE+++++++++++++++++++++++++++')
console.log(configurationMobile)
  return (
    <div>
      <form onSubmit={handleSubmit}>
        <div className='rounded img-fluid'
         style={divStyle} 
        >
          <div className={`${styles.editCircle} ${enableEdit ? styles.clicked : ''}`} onClick={handleEdit} title='Editar'>
            <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M0 15.4596V18.4996C0 18.7796 0.22 18.9996 0.5 18.9996H3.54C3.67 18.9996 3.8 18.9496 3.89 18.8496L14.81 7.93957L11.06 4.18957L0.15 15.0996C0.0500001 15.1996 0 15.3196 0 15.4596ZM17.71 5.03957C18.1 4.64957 18.1 4.01957 17.71 3.62957L15.37 1.28957C14.98 0.89957 14.35 0.89957 13.96 1.28957L12.13 3.11957L15.88 6.86957L17.71 5.03957Z" fill="#ED0045"/>
            </svg>
          </div>

          <div style={{ marginTop: '40px' }}>
            {showEventNameInput || enableEdit ? (
              <input
                type="text"
                id="event-name"
                name="event_name"
                value={formData.event_name}
                onChange={handleInputChange}
                className={`${styles.inputsborder} ${styles.eventName}`}
                placeholder='Titulo del evento'
                onBlur={showHideEventNameInput}
                ref={inputEventNameRef}
                onKeyDown={(e) => { if (e.key === 'Enter') { showHideEventNameInput(); } }}
              />
            ) : (
              <label className={styles.eventName} style={configurationMobile.titulo} htmlFor="event-name" onClick={showHideEventNameInput}>
                {dataInvitation?.event_name ? dataInvitation?.event_name : 'Titulo del evento'}
              </label>
            )}
          </div>

          <div style={{ marginTop: '40px' }}>
            {showEventDateInput || enableEdit ? (
              <input
                type="date"
                id="event-date"
                name="event_date"
                value={formData.event_date}
                onChange={handleInputChange}
                className={`${styles.inputsborder} ${styles.eventDate} ${styles.inputEventDate}`}
                placeholder='Fecha del evento'
                onBlur={showHideEventDateInput}
                ref={inputEventDateRef}
                onKeyDown={(e) => { if (e.key === 'Enter') { showHideEventDateInput(); } }}
              />
            ) : (
              <label className={`${styles.eventDate}`} htmlFor="event-date" onClick={showHideEventDateInput} >
                {dataInvitation?.event_date ? dataInvitation?.event_date : 'Fecha del evento'}
              </label>
            )}
          </div>

          <div>
            {showEventHourInput || enableEdit ? (
              <input
                type="time"
                id="event-hour"
                name="time"
                value={formData.time}
                onChange={handleInputChange}
                className={`${styles.inputsborder} ${styles.hourEvent} ${styles.inputHourDate}`}
                placeholder='Hora del evento'
                onBlur={showHideEventHourInput}
                ref={inputEventHourRef}
                onKeyDown={(e) => { if (e.key === 'Enter') { showHideEventHourInput(); } }}
              />
            ) : (
              <label className={styles.hourEvent} htmlFor="event-hour" onClick={showHideEventHourInput}>
                {dataInvitation?.event_hour ? dataInvitation?.event_hour : 'Hora del evento'}
              </label>
            )}
          </div>

          <div>
            {showCelebrateNameInput || enableEdit ? (
              <input
                type="text"
                id="celebrate-name"
                name="celebrate_name"
                value={formData.celebrate_name}
                onChange={handleInputChange}
                className={`${styles.inputsborder} ${styles.celebratedName}`}
                placeholder='Nombre de los festejados'
                onBlur={showHideCelebrateNameInput}
                ref={inputCelebrateNameRef}
                onKeyDown={(e) => { if (e.key === 'Enter') { showHideCelebrateNameInput(); } }}
              />
            ) : (
              <label className={styles.celebratedName} htmlFor="celebrate-name" onClick={showHideCelebrateNameInput}>
                {dataInvitation?.name ? dataInvitation?.name : 'Nombre de los festejados'}
              </label>
            )}
          </div>

          <div>
            {showPlaceEventInput || enableEdit ? (
              <input
                type="text"
                id="address"
                name="address"
                value={formData.address}
                onChange={handleInputChange}
                className={`${styles.inputsborder} ${styles.directionEvent}`}
                placeholder='Lugar del evento'
                onBlur={showHidePlaceEventInput}
                ref={inputPlaceEventRef}
                onKeyDown={(e) => { if (e.key === 'Enter') { showHidePlaceEventInput(); } }}
              />
            ) : (
              <label className={styles.directionEvent} htmlFor="celebrate-name" onClick={showHidePlaceEventInput}>
                {dataInvitation?.address ? dataInvitation?.address : 'Lugar del evento'}
              </label>
            )}
          </div>

          <div>
            {showMessageInput || enableEdit ? (
              <textarea
                id="message"
                name="message"
                value={formData.message}
                onChange={handleInputChange}
                className={`${styles.inputsborder} ${styles.message} ${styles.inputMessage}`}
                placeholder='Mensaje'
                onBlur={showHideMessageInput}
                ref={inputMessageRef}
              />
            ) : (
              <label className={styles.message} htmlFor="message" onClick={showHideMessageInput}>
                {dataInvitation?.message ? dataInvitation?.message : 'Mensaje'}
              </label>
            )}
          </div>
        </div>
        <div className="justify-content-center">
          <div className='col-md-12 mb-1 mt-1'>
            <Button
              id={11}
              variant="primary"
              onClick={handleSubmit}
              type="button"
              className="col-md-12">
              Guardar
            </Button>
          </div>
          <div className='col-md-12'>
            <Button
              id={1}
              variant="secondary"
              onClick={handleClickBackFather}
              type="button"
              className="col-md-12">
              Cambiar tema
            </Button>
          </div>
        </div>
      </form>

    </div>
  );
}

export default InvitationFormMobile;
